import styled from "styled-components";

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  border-bottom: 1px solid #f2f4f7;
  padding: 20px 30px 20px 300px;
  @media only screen and (max-width: 820px) {
    padding: 20px;
  }
  h2 {
    font-weight: 500;
  }
`;

export const HeaderTitle = styled.div`
  display: flex;
  gap: 1rem;

  .hamburger-icon {
    font-size: 25px;
    display: none;
    @media (max-width: 820px) {
      display: block;
    }
  }
`;

export const HeaderComponents = styled.div`
  display: flex;
  gap: 2rem;
`;

export const Searchbar = styled.div`
  position: relative;
  input {
    width: 30vw;
    height: 50px;
    border-radius: 36px;
    border: 1px solid #eeeff7;
    padding: 16px 15px 15px 40px;
    color: #000;
    font-size: 1rem;
    &:focus {
      outline: none;
      border-color: #9574f1;
    }
  }
  img {
    position: absolute;
    top: 20px;
    left: 15px;
  }
  @media (max-width: 991px) {
    display: none;
  }
`;

export const HeaderIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  .dropBtn {
    display: flex;
  }

  .circled {
      background-color: #03a9f4;
      border-radius: 50%;
      padding: 10px;
      font-size: 20px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 40px;
      height: 40px;
    }
  .caret {
    width: 15px;
    margin-top: 15px;
    margin-left: 5px;
    transform: translateY(-1px);
  }
  .dropdown-content {
    //visibility: hidden;
    position: absolute;
    top: 8%;
    right: -5%;
    transform: translateX(-50%);
    background-color: #fff;
    min-width: 170px;
    font-size: 14px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    overflow-x: hidden;
    opacity: 0;
    border-radius: 7px;
    max-height: 0px;
    transition: max-height 0.6s ease;

    a {
      color: #000;
      padding: 12px 16px;
      text-decoration: none;
      display: block;
      text-align: left;

      &:hover {
        background-color: #f1f1f1;
      }
    }
  }

  .nav-item:hover .dropdown-content {
    visibility: visible;
    height: auto;
    max-height: 300px;
    opacity: 1;
    transition: max-height 1.5s, opacity 0.2s, visibility 4s ease;
  }

  .notification-badge {
    position: absolute;
    top: -15px;
    right: -20px;
    background-color: red;
    color: white;
    border-radius: 50%;
    padding: 5px 10px;
    font-size: 12px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const MenuHeader = styled.div`
  color: #000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;

  h3 {
    font-size: 17px;
    color: #101828;
  }
  .close-menu {
    cursor: pointer;
    font-size: 29px;
  }
`;

export const NavigationContainer = styled.div`
  padding: 0px 20px;
  position: absolute;
  top: 8%;
  right: -10%;
  transform: translateX(-50%);
  border-radius: 12px;
  background-color: #fff;
  min-width: 170px;
  font-size: 14px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  width: 400px;
  height: 100%;
  transition: 0.5s;
  overflow-y: auto;
  max-height: 500px; // Adjust the height as needed
  
  .clear {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      span {
        color: #989fad;
        font-size: 12px;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  .wrapper {
    padding-bottom: 8px;
    margin-bottom: 15px;
    //cursor: pointer;
    border-bottom: solid 1px #e0e0e0;
    h4 {
      color: #344054;
      font-size: 13px;
      line-height: 20px;
    }
  }
`;
